import { StatusIcon } from "~/components/icons/status"
import type { IssueStatus } from "~/lib/enums"

export function IssuePickerOption({
	identifier,
	title,
	status,
	moving
}: {
	identifier: string
	title: string
	status: IssueStatus
	moving?: boolean
}) {
	return (
		<div
			className="flex min-w-0 flex-1 items-center gap-2"
			title={`${identifier} ${title}`}
		>
			<StatusIcon status={status} className="size-4 shrink-0" />
			<span className="shrink-0 text-xs text-text-sub">{identifier}</span>
			<div className="min-w-0 flex-1">
				<div className="truncate">{title}</div>
				{moving && (
					<div className="text-xs text-text-sub">Move to this project</div>
				)}
			</div>
		</div>
	)
}
